<template>
  <div id="page-top">
    <div id="wrapper">
      <Navbar></Navbar>
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          <Topbar></Topbar>
          <div class="container-fluid">
            <transition name="fade">
              <div id="preloader">
                <div data-loader="circle-side"></div>
              </div>
            </transition>
            <transition name="fade">
              <div id="loader_form">
                <div data-loader="circle-side-2"></div>
              </div>
            </transition>
            <div class="card shadow mb-4">
              <div class="card-header py-3 d-flex align-items-center justify-content-between">
                <h6 class="m-0 font-weight-bold text-dark">Entreprises</h6>
                <a class="btn btn-sm btn-success shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#addModalCompany" v-bind:disabled="addCompanyProcess || editCompanyProcess || deleteCompanyProcess"><i class="fas fa-plus fa-md"></i></a>
              </div>
              <div class="card-body">
                <transition name="fade">
                  <div v-if="messageAlert" class="alert p-3" v-bind:class="{ 'alert-success': isSuccess, 'alert-danger': isError }" role="alert">
                    {{messageAlert}}
                  </div>
                </transition>
                <div class="table-responsive">
                  <table class="table table-hover table-bordered" id="dataTableCompany" width="100%" cellspacing="0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Pays</th>
                        <th>Code</th>
                        <th>Nom</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tfoot>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Pays</th>
                        <th>Code</th>
                        <th>Nom</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </tfoot>
                    <tbody>
                      <tr v-for="(item, index) in companies" v-bind:key="item.id">
                        <td>{{index+1}}</td>
                        <td class="d-none">{{item.id}}</td>
                        <td>{{getPaysName(item.country_id)}}</td>
                        <td>{{item.code}}</td>
                        <td>{{item.name}}</td>
                        <td class="text-center">
                          <a class="btn btn-sm btn-primary shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#viewModalCompany" v-on:click="viewCompany(item.id)" v-bind:disabled="addCompanyProcess || editCompanyProcess || deleteCompanyProcess">
                          <i class="fas fa-eye fa-md"></i>
                          </a>
                          <a class="btn btn-sm btn-warning shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#editModalCompany" v-on:click="viewCompany(item.id)" v-bind:disabled="addCompanyProcess || editCompanyProcess || deleteCompanyProcess">
                          <i class="fas fa-pencil-alt fa-md"></i>
                          </a>
                          <a class="btn btn-sm btn-danger shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#deleteModalCompany" v-on:click="viewCompany(item.id)" v-bind:disabled="addCompanyProcess || editCompanyProcess || deleteCompanyProcess">
                          <i class="fas fa-trash fa-md"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
    <a class="scroll-to-top rounded" href="#page-top">
    <i class="fas fa-angle-up"></i>
    </a>
    <!-- Add Modal Company -->
    <div class="modal fade" id="addModalCompany" tabindex="-1" role="dialog" aria-labelledby="ModalCompanyLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="addCompanyForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalCompanyLabel">Ajouter Entreprise</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-6">
                  <label for="country_id1">Pays</label>
                  <select class="form-control mb-2" v-model="country_id1" name="country_id1" required>
                    <option v-for="country in countries" :key="country.id" :value="country.id">
                      {{ country.name }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label>Code</label>
                  <input type="text" class="form-control mb-2" v-model="code1" name="code1" required>
                </div>
                <div class="col-sm-12">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="name1" name="name1" required>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-success text-uppercase w-50" href="javascript:(0)" v-on:click="addCompany" v-bind:disabled="addCompanyProcess || editCompanyProcess || deleteCompanyProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="addCompanyProcess">
              Ajouter
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- View Modal Company -->
    <div class="modal fade" id="viewModalCompany" tabindex="-1" role="dialog" aria-labelledby="ModalCompanyLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalCompanyLabel">Entreprise [#<span>{{indexCompany+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th scope="row">Id</th>
                  <td>{{id2}}</td>
                </tr>
                <tr>
                  <th scope="row">Code</th>
                  <td>{{code2}}</td>
                </tr>
                <tr>
                  <th scope="row">Nom</th>
                  <td>{{name2}}</td>
                </tr>
                <tr>
                  <th scope="row">Pays</th>
                  <td>{{getPaysName(country_id2)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary text-uppercase w-50" href="javascript:(0)" data-dismiss="modal">
            Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Modal Company -->
    <div class="modal fade" id="editModalCompany" tabindex="-1" role="dialog" aria-labelledby="ModalCompanyLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="editCompanyForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalCompanyLabel">Modifier Entreprise [#<span>{{indexCompany+1}}</span>]</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-6">
                  <label for="country_id1">Pays</label>
                  <select class="form-control mb-2" v-model="country_id3" name="country_id3" required>
                    <option v-for="country in countries" :key="country.id" :value="country.id">
                      {{ country.name }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label>Code</label>
                  <input type="text" class="form-control mb-2" v-model="code3" name="code3" required>
                </div>
                <div class="col-sm-12">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="name3" name="name3" required>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-warning text-uppercase w-50" href="javascript:(0)" v-on:click="editCompany" v-bind:disabled="addCompanyProcess || editCompanyProcess || deleteCompanyProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="editCompanyProcess">
              Modifier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- delete Modal Company -->
    <div class="modal fade" id="deleteModalCompany" tabindex="-1" role="dialog" aria-labelledby="ModalCompanyLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalCompanyLabel">Supprimer Entreprise [#<span>{{indexCompany+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-center text-uppercase mt-3">êtes-vous sûr de vouloir supprimer ce pays ?</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-danger text-uppercase w-50" href="javascript:(0)" v-on:click="deleteCompany" v-bind:disabled="addCompanyProcess || editCompanyProcess || deleteCompanyProcess">
            <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="deleteCompanyProcess">
            Supprimer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s
}
.fade-enter,
.fade-leave-to {
  opacity: 0
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  z-index: 999999;
}
[data-loader="circle-side"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
#loader_form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 999999;
  display: none;
}
[data-loader="circle-side-2"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
@-webkit-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>

<script>
import Navbar from './Navbar'
import Topbar from './Topbar'
import Footer from './Footer'
import axios from 'axios'
$.fn.isValid = function () {
  return this[0].checkValidity()
}
export default {
  name: 'App',
  components: {
    'Topbar': Topbar,
    'Navbar': Navbar,
    'Footer': Footer
  },
  data () {
    return {
      loading: true,
      progress: 0,
      company: {},
      indexCompany: '',
      countries: [],
      companies: [],
      isSuccess: true,
      isError: false,
      messageAlert: '',
      addCompanyProcess: false,
      viewCompanyProcess: false,
      editCompanyProcess: false,
      deleteCompanyProcess: false,
      code1: '',
      name1: '',
      country_id1: '',
      id2: '',
      code2: '',
      name2: '',
      country_id2: '',
      code3: '',
      name3: '',
      country_id3: '',
      dTableCompany: ''
    }
  },
  methods: {
    //Initialiser variables et tables
    init () {
      setTimeout(() => {
        this.dTableCompany = $('#dataTableCompany').DataTable({
          'columns': [
            { 'width': '15' },
            null,
            null,
            null,
            null,
            { 'width': '100' }
          ],
          'lengthMenu': [
            [10],
            [10]
          ],
          order: [
            [0, 'desc']
          ],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          deferRender: true,
          fixedColumns: true
        })
        this.company = {
          'id': '',
          'code': '',
          'name': '',
          'country_id': ''
        }
        this.code1 = ''
        this.name1 = ''
        this.country_id1 = ''
        this.id2 = ''
        this.code2 = ''
        this.name2 = ''
        this.country_id2 = ''
        this.code3 = ''
        this.name3 = ''
        this.country_id3 = ''
      }, 50)
    },
    //Sélectionner tous les pays (Base de données)
    getCompanies () {
      axios.get(this.apiUrl+'/companies', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.companies = res.data
          this.progress += 1
          if (this.progress === 2) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //Sélectionner toutes les Payss (Base de données)
    getPays () {
      axios.get(this.apiUrl+'/countries', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.countries = res.data
          this.progress += 1
          if (this.progress === 2) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    getPaysName(countryId) {
          const country = this.countries.find((a) => a.id === countryId);
          return country ? country.name : ''; // Devuelve el nombre o un valor predeterminado
    },
    //Ajouter un pays
    addCompany () {
      if ($('#addCompanyForm').isValid()) {
        this.addCompanyProcess = true
        let company = {
          id: this.companies.length + 1,
          code: this.code1,
          name: this.name1,
          country_id: this.country_id1
        }
        axios.post(this.apiUrl+'/companies', company, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 201) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement ajouté avec succès'
            this.companies.push(company)
            this.dTableCompany.destroy()
            this.init()
          }
          $('#addModalCompany').modal('hide')
          this.addCompanyProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#addModalCompany').modal('hide')
          this.addCompanyProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    //Sélectionner un pays (Local)
    viewCompany (id) {
      this.company = this.companies.filter(function (item) {
        return item.id === id
      })[0]
      this.indexCompany = this.companies.indexOf(this.company)
      this.id2 = this.company.id
      this.code2 = this.company.code
      this.name2 = this.company.name
      this.country_id2 = this.company.country_id
      this.code3 = this.company.code
      this.name3 = this.company.name
      this.country_id3 = this.company.country_id
    },
    //Modifier un pays
    editCompany () {
      if ($('#editCompanyForm').isValid()) {
        var id = this.company.id
        this.editCompanyProcess = true
        axios.put(this.apiUrl+'/companies/' + id, {
          code: this.code3,
          name: this.name3,
          country_id: this.country_id3,
        }, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement modifié avec succès'
            this.company.code = this.code3
            this.company.name = this.name3
            this.company.country_id = this.country_id3
            this.companies[this.indexCompany] = this.company
            this.dTableCompany.destroy()
            this.init()
          }
          $('#editModalCompany').modal('hide')
          this.editCompanyProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#editModalCompany').modal('hide')
          this.editCompanyProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    //Supprimer un pays
    deleteCompany () {
      var id = this.company.id
      this.deleteCompanyProcess = true
      axios.delete(this.apiUrl+'/companies/' + id, {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement supprimé avec succès'
            this.companies.splice(this.indexCompany, 1)
            this.dTableCompany.destroy()
            this.init()
          }
          $('#deleteModalCompany').modal('hide')
          this.deleteCompanyProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          this.addCompanyProcess = false
          $('#deleteModalCompany').modal('hide')
          setTimeout(function () {
            this.messageAlert2 = ''
          }.bind(this), 3500)
        })
    }
  },
  created () {
    $('body').css({'overflow': 'hidden'})
    this.getPays()
    this.getCompanies()
  },
  watch: {
    loading: function () {
      this.init()
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      $('[data-loader="circle-side"]').fadeOut()
      $('#preloader').delay(350).fadeOut('slow')
      $('body').delay(350).css({
        'overflow': 'auto'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Company.vue